module.exports = __webpack_public_path__ + "static/media/KPMG.93edd56f.png";